(function () {
  var gallery = document.querySelector('[data-gallery]');
  var counter = document.querySelector('[data-count]');
  if (gallery && counter) {
    var slides = gallery.querySelectorAll('.pdp-slide');
    if (slides.length > 1) {
      var update = function () {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
        counter.textContent = i + ' / ' + slides.length;
      };
      gallery.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    } else {
      counter.hidden = true;
    }
  }
  document.querySelectorAll('.menu-panel a').forEach(function (a) {
    a.addEventListener('click', function () {
      var d = a.closest('details');
      if (d) d.removeAttribute('open');
    });
  });
  document.querySelectorAll('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = b.getAttribute('data-copy');
      var l = b.querySelector('[data-copy-label]');
      var done = function () { if (l) l.textContent = 'Kopiert ✓'; };
      if (navigator.clipboard) { navigator.clipboard.writeText(t).then(done, done); } else { done(); }
    });
  });
  var items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('in'); });
  }
})();
